export const hexToRgb = (hex: string): string => {
  if (!hex) return;
  if (hex[0] !== '#') return hex;
  const hexValue = hex.replace('#', '');
  const r = parseInt(hexValue.substring(0, 2), 16);
  const g = parseInt(hexValue.substring(2, 4), 16);
  const b = parseInt(hexValue.substring(4, 6), 16);
  return `rgb(${r},${g},${b})`;
};

export const hexToRgba = (hex: string): string => {
  if (!hex) return;
  if (hex[0] !== '#') return hex;
  const hexValue = hex.replace('#', '');
  const r = parseInt(hexValue.substring(0, 2), 16);
  const g = parseInt(hexValue.substring(2, 4), 16);
  const b = parseInt(hexValue.substring(4, 6), 16);
  const a = parseFloat((parseInt(hexValue.substring(6, 8), 16) / 255).toFixed(2));
  return `rgba(${r},${g},${b},${a})`;
};

export const rgbToHex = (rgba: string, forceRemoveAlpha = false): string => {
  if (!rgba) return;
  return (
    '#' +
    rgba
      .replace(/^rgba?\(|\s+|\)$/g, '') // Get's rgba / rgb string values
      .split(',') // splits them at ","
      .filter((string, index) => !forceRemoveAlpha || index !== 3)
      .map(string => parseFloat(string)) // Converts them to numbers
      .map((number, index) => (index === 3 ? Math.round(number * 255) : number)) // Converts alpha to 255 number
      .map(number => number.toString(16)) // Converts numbers to hex
      .map(string => (string.length === 1 ? '0' + string : string)) // Adds 0 when length of one number is 1
      .join('')
  ); // Puts the array to togehter to a string
};
